import React, {useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import ClientSupportChat from "../common/support_chat/client_support_chat";

export default function SupportChat({data, onModalClose, imageMap}) {
  if (!imageMap) {
    return <div>Missing image map.</div>
  }

  const tagOwner = useSelector((state) => state.tagOwner)
  // const accountOrganization = imageMap.account_organization
  const accountOrganization = useSelector((state) => state.accountOrganizations?.find((accountOrganization) => accountOrganization.id === imageMap.account_organization_id))
  const supportChatSessionId = useSelector((state) => state.supportChatSessionId)
  const isBoothEditor = useSelector((state) => state.isBoothEditor)
  const supportChatSessions = useSelector((state) => state.supportChatSessions.filter((supportChatSession) => supportChatSession.tag_owner_id === tagOwner?.id && supportChatSession.account_organization_id === accountOrganization?.id))
  const supportChatSession = supportChatSessions.find((supportChatSession) => supportChatSession.id === supportChatSessionId)

  const isCustomPopupPositionEnabled = data?.supportChatData?.customize_popup_position == "true" || data?.supportChatData?.customize_popup_position == true

  const modalContent = (styles) => {
    let bodyStyle = styles?.bodyStyle
    if (!bodyStyle) {
      bodyStyle = supportChatSession ? {} : {maxHeight: "40vh", overflowY: "auto", overflowX: "hidden"}
    }

    return <div style={styles?.style} className="modal-content" onClick={(event) => {
      event.stopPropagation()
    }}>
      <div className="modal-header">
        <div className="modal-title">
          {data.title}
        </div>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={() => {
            onModalClose ? onModalClose() : alert("No modal close action available.")
          }}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body p-0 styled-scrollbar"
           style={{...bodyStyle, display: "flex", flexDirection: "column"}}>

        <ClientSupportChat imageMap={imageMap}/>
      </div>
    </div>
  }

  if (isCustomPopupPositionEnabled) {
    const style = {
      zIndex: 1049,
      position: "fixed",
      maxWidth: "90%",
      maxHeight: "90%",
      height: "500px",
      width: "350px"
    }

    if (isBoothEditor) {
      style.position = "absolute"
    }

    switch (data?.supportChatData?.popup_position) {
      case "top-left":
        style["top"] = "15px";
        style["left"] = "15px";
        break;
      case "top-right":
        style["top"] = "15px";
        style["right"] = "15px";
        break;
      case "bottom-left":
        style["bottom"] = "50px"; // navigation
        style["left"] = "15px";
        break;
      case "bottom-right":
      default:
        style["bottom"] = "50px"; // navigation
        style["right"] = "15px";
        break;
    }

    return <div style={style}>
      {modalContent({style: {maxHeight: "100%", height: "100%"}, bodyStyle: {maxHeight: "unset"}})}
    </div>
  }

  return <div className="modal preview-modal" role="dialog" tabIndex="-1"
              onClick={(event) => {
                onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
    <div className="modal-dialog" role="document">
      {modalContent({})}
    </div>
  </div>;
}

